/**
 * Parse Value With Unit Utility
 *
 * Utility function for parsing value to separate numeric value and unit
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Parse value to separate numeric value and unit
 */
export const parseValueWithUnit = (
	value: string | number | undefined,
): { value: string; unit: string } => {
	if ( ! value || value === '' || value === 'auto' ) {
		return { value: String( value ?? '' ), unit: 'px' };
	}

	const stringValue = String( value );
	const match = stringValue.match( /^(-?\d*\.?\d+)([a-zA-Z%]*)$/ );

	if ( match ) {
		return {
			value: match[ 1 ],
			unit: match[ 2 ] || 'px',
		};
	}

	return { value: stringValue, unit: 'px' };
};
